// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"styles_cardContainer__1ppvi","title":"styles_title__nzytx"};